import { ToastMessageContext } from "lib/contexts/message_context";
import ReportsServices from "lib/services/api/reports/reports";
import { getOrganisationId, getUserId } from "lib/utils/common_utils";
import useDebounce from "lib/utils/debounce";
import React, { useContext, useEffect, useState } from "react";

const useGetReportsTableData = (
  filterValues,
  searchText,
  page,
  pageSize,
  type
) => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const message = useContext(ToastMessageContext);

  const debouncedSearchText = useDebounce(searchText);

  const getReportsTableData = async () => {
    try {
      setLoading(true);
      const params = {
        page: page + 1,
        limit: pageSize,
        search: debouncedSearchText || "",
        organisation_id: getOrganisationId(),
      };
      if (type !== "admin") {
        params["user_id"] = getUserId();
      }

      for (let i in filterValues) {
        if (filterValues[i] !== "") {
          params[i] = filterValues[i];
        }
      }
      const reqFuncs = {
        favourites: ReportsServices.getFavouriteReports,
        allReports: ReportsServices.getAllReports,
        admin: ReportsServices.getAdminReports,
      };

      const response = reqFuncs[type] && (await reqFuncs[type](params));
      if (response?.success) {
        setData(response.data);
        setTotalCount(response.total_count);
      } else {
        throw new Error();
      }
    } catch (error) {
      setData([]);
      setTotalCount(0);
      message.showToastMessage({
        message: "Something went wrong. Try Again!",
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getReportsTableData();
  }, [page, pageSize, filterValues, debouncedSearchText]);

  return { loading, tableData: data, totalCount, refetch: getReportsTableData };
};

export default useGetReportsTableData;
